<template>
  <div class="contents brandtop">
    <div class="brandtop-left">
        <img :src="brandInfo.image" />
    </div>
    <div class="brandtop-right">
        <div class="brandtop-right-title">{{otherInfo.bannerNmae}}</div>
        <div class="brandtop-right-middle">
            <span class="brandtop-right-middle-item">
                成立时间<span class="item-val">{{otherInfo.createTime}}</span>
            </span>
            <span class="brandtop-right-middle-item">
                所在地区<span class="item-val">{{otherInfo.area}}</span>
            </span>
        </div>

        <div class="brandtop-right-list">
            <i class="icon iconfont icon-renzhengguanli"></i>
            <ul>
                <li v-for="(item,index) in otherInfo.honor" :key="index">
                    {{item}}
                </li>
            </ul>
            
        </div>
    </div>
  </div>
</template>

<script>
export default {
    props:{
        brandInfo: {
            type: Object,
            required: true,
            default: function () {
                return {}
            }
        },
        otherInfo: {
            type: Object,
            required: true,
            default: function () {
                return {}
            }
        }
    }
}
</script>

<style  scoped>
    .brandtop{
        display: flex;
        justify-content: flex-start;
        padding: 10px 5px;

    }
    .brandtop .brandtop-left{
        width: 179px;
        height: 98px;
        background-color: #fff;
        text-align: center;  
        box-shadow: 0 0 6px rgba(0, 0, 0, 0.12); 
        border-radius: 5px;
    }
    .brandtop .brandtop-left img{
        max-width: 100%;
        max-height: 100%;
    }
    .brandtop-right{
        margin-left: 30px;
        margin-top: -5px;
    }
    .brandtop-right .brandtop-right-title{
        color: #333333;
        font-size: 28px;
    }
    .brandtop-right .brandtop-right-middle{
        margin: 12px 0;
    }
    .brandtop-right .brandtop-right-middle .brandtop-right-middle-item{
        color: #B9B9B9;
        font-size: 14px;
        line-height: 18px;
    }
    .brandtop-right-middle-item .item-val{
        font-size: 14px;
        color: #333333;
        margin-left: 5px;
        margin-right: 20px;
    }
    .brandtop-right .brandtop-right-list{
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    .brandtop-right-list .icon-renzhengguanli{
        color:#2655AE ;
        font-size: 20px;
    }
    .brandtop-right .brandtop-right-list ul{
        display: flex;
        flex-direction: row;
        align-items: center;
        color:#2655AE;
    }
    .brandtop-right-list ul li{
        padding:0 9px;
        position: relative;       
    }
    .brandtop-right-list ul li::after{
        position: absolute;
        content: " ";
        right: 0;
        top: 6px;
        width: 1px;
        height: 10px;
        background-color: #CFCFCF;
        /* border-left: 1px solid #CFCFCF ; */
    }
    .brandtop-right-list ul li:last-child::after{
        display: none;
    }
     

</style>


// WEBPACK FOOTER //
// src/components/brand/BrandTop.vue